//
//
//
//
//
//
//
//
//
//
//

import { onSSR } from '@vue-storefront/core';
import Home0 from '~/components/Home0.vue';
import Home1 from '~/components/Home1.vue';
import { useCache, CacheTagPrefix } from '@bee-hole/cache';
import HomeModal from '~/components/HomeModal/index.vue';
export default {
  name: 'Home',
  components: {
    Home0,
    Home1,
    HomeModal
  },
  layout({ app }) {
    return app?.$storeConfig?.mall_home_type || 'default';
  },
  setup(props, context) {
    const { addTags } = useCache();
    const { root } = context;
    // console.log('Home setup', root.$options.$storeConfig);
    onSSR(async () => {
      try {
        addTags([
          { prefix: CacheTagPrefix.View, value: 'home', dataPrefix: context.root.$options.$storeConfig?.mall_cache_pre }
        ]);
      } catch (e) {
        console.log('===addTags error:', e);
      }
    });

    return {
      $storeConfig: root.$options.$storeConfig
    };
  }
};
